import type { notifyJobModuleCompletedProps } from "./job-module-action-completed.type";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";

import { JobModuleActionLink } from "../job-module-action-link";

export const notifyJobModuleCompleted = ({
  notify,
  title,
  payload,
}: notifyJobModuleCompletedProps) => {
  notify.success({
    key: payload.id,
    title: title,
    description: payload.job_module.subjects[0].name,
    descriptionRows: 2,
    actions: (
      <>
        <JobModuleActionLink
          customContext={payload.context}
          subject={payload.job_module.subjects[0]}
          onClick={() => notify.close(payload.id)}
        />
        <OrganizationContextLabel context={payload.context} isSmall />
      </>
    ),
    duration: ONE_MINUTE_IN_SECONDS,
  });
};
